 <template>
     <div>        
        <GestionLideres ref="gestion"></GestionLideres>
        <div class="row align-items-end" v-if="($store.state.user.role_id === 1 || $store.state.user.role_id === 2 || $store.state.user.role_id === 4) && !lideresSublideres">        
            <div class="col-md-5 col-12">
                <model-select
                    id="coordinador"
                    :options="coordinadores"
                    v-model="coordinadore_id"
                    placeholder="Mostrar todo"
                ></model-select>
            </div>
            <div class="col-md-2 col-12">
                <button class="btn btn-dark btn-block" @click="buscarCoordinador" style="height: 38px; padding: 0;">Buscar</button>
            </div>
        </div>
        <a-row type="flex" class="mt-30" v-if="loading">
            <a-spin size="large" class="text-center"/>
        </a-row>
        <div v-if="mostrarMensajeSinResultados" class="alert alert-warning text-center mt-3">
            <i class="fas fa-exclamation-triangle"></i>
            <strong>Sin resultados</strong>
            <p class="mb-0">Este coordinador no tiene registros agregados.</p>
        </div>
        <a-card :bordered="false" class="header-solid h-full mt-10" :bodyStyle="{padding: 0,}" v-if="infoCoordinador.length > 0">
            <template #title>
                <div class="d-flex justify-content-between">
                    <div>
                        <h6 class="my-3" v-if="coordinadore_id > 0">{{ coordinador }}</h6>
                        <p class="meta-badge">Meta: <span class="meta-value">{{ infoCoordinador[0].meta_votacion }}</span></p>
                    </div>
                    <div>
                        <button class="btn btn-danger mr-2" @click="newLider"><b-icon icon="file-plus"></b-icon> Nuevo lider</button>
                        <a :href="'https://apisenado.convexosit.co/excel-coordinadores/' + $store.state.user.token_id + '/' + coordinadore_id  + '/-1/-1'" class="btn btn-success" target="_blank" v-if="($store.state.user.role_id === 1 || $store.state.user.role_id === 2)"> <b-icon icon="file-earmark-excel"></b-icon> Generar excel</a>
                    </div>
                </div>
                <p class="info-coordinadores"><strong># Lideres:</strong>
                    <b-badge variant="danger" @click="irLideres" role="button">{{ infoCoordinador[0].total_lideres }}</b-badge>
                </p>
                <p class="info-coordinadores"><strong># Militantes:</strong> {{ totalMilitantes }}</p>
                
                <!-- Switch de agrupación -->
                <div class="text-center my-4">
                    <div class="agrupacion-switch">
                        <label class="switch-label" :class="{ active: agrupacion === 1 }">
                            <input 
                                type="radio" 
                                :value="1" 
                                v-model="agrupacion" 
                                @change="buscarCoordinador"
                                class="switch-input"
                            >
                            <span class="switch-text">Departamento</span>
                        </label>
                        <label class="switch-label" :class="{ active: agrupacion === 2 }">
                            <input 
                                type="radio" 
                                :value="2" 
                                v-model="agrupacion" 
                                @change="buscarCoordinador"
                                class="switch-input"
                            >
                            <span class="switch-text">Municipio</span>
                        </label>
                    </div>
                </div>
            </template>
            
            <ChartBar :height="300" :data="barChartData"></ChartBar>
        </a-card>
        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}" >
            <Lideres ref="lideres" @reset="resetear" />
        </a-card>
    </div>
 </template>
 <script>

    import { ModelSelect } from "../../node_modules/vue-search-select/dist/VueSearchSelect.common";
    import GestionLideres from "../components/Config/lider/GestionLideres.vue";    
    import Lideres from "@/components/Coordinadores/Lideres.vue";
    import ChartBar from "@/components/Charts/ChartBar.vue";

    import axios from 'axios';
    export default {
        components:{
            GestionLideres, ModelSelect, Lideres, ChartBar
        },
        data() {
            return {
                agrupacion: 1,
                barChartData: {                
                    datasets: [
                        {
                            label: "",
                            backgroundColor: ['green', 'red'],
                            borderWidth: 5,
                            borderSkipped: false,
                            borderRadius: 0,
                            data: [],
                            maxBarThickness: 20,
                        }, 
                    ],
                    labels: ["Militantes", 'meta'],
                },
                coordinador: '',
                coordinadore_id: -1,
                coordinadores: [],
                infoCoordinador: [],
                lideresSublideres: false,
                loading: false,
                busquedaRealizada: false
            }
        },
        mounted(){
            if(this.$store.state.user.role_id === 6 || this.$store.state.user.role_id === 5){
                this.coordinadore_id = this.$store.state.user.id;                
                this.irLideres();
            }else{
                this.getCoordinadores();
            }
        },
        methods: {
            buscarCoordinador(){

                if(this.coordinadore_id === -1 || this.coordinadore_id === null || this.coordinadore_id === '' || this.coordinadore_id === undefined){
                    this.coordinadore_id = -1;
                }else{
                    const coordinadorEncontrado = this.coordinadores.find(coord => coord.value === this.coordinadore_id);
                    if(coordinadorEncontrado) {
                        this.coordinador = coordinadorEncontrado.text;
                    }
                }

                this.infoCoordinador = [];
                this.loading = true;
                this.busquedaRealizada = false;
                axios.get(`api/info-coordinadores/${this.coordinadore_id}/${this.agrupacion}`, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            console.log(res.data);
                            this.busquedaRealizada = true;
                            if(res.data.info.length > 0){
                                this.setChart(res.data.info)
                                this.infoCoordinador = res.data.info;
                            }
                            this.loading = false;
                        })
                        .catch(err => {
                            this.loading = false;
                            this.busquedaRealizada = true;
                            console.log(err)
                        })
            },
            getCoordinadores(){
                if(this.$store.state.user.role_id === 1 || this.$store.state.user.role_id === 2 || this.$store.state.user.role_id === 4){
                    axios.get(`api/coordinadores/${this.$store.state.user.candidato_id}`, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.user.token}`
                        }
                    })
                        .then(res => {
                            if(res.data.coordinadores.length >0){
                                for (let i = 0; i < res.data.coordinadores.length; i++) {
                                    this.coordinadores.push({
                                        text: res.data.coordinadores[i].nombres + ' ' + res.data.coordinadores[i].apellidos,
                                        value: res.data.coordinadores[i].id
                                    })
                                }                            
                            }
                        })
                        .catch(err => console.log(err))
                }else{
                    this.coordinadore_id = this.$store.state.user.id;
                    this.buscarCoordinador();
                }
            },
            irLideres(){
                this.lideresSublideres = true;
                this.infoCoordinador = [];
                if(this.$store.state.user.role_id === 5){
                    this.$refs.lideres.getSublideres(this.coordinadore_id);
                }else{
                    this.$refs.lideres.getLideres(this.coordinadore_id);
                }
            },
            newLider(){
                this.$refs.gestion.newLider()
            },
            resetear(){
                this.lideresSublideres = false;
            },
            setChart(info){
                console.log(info);
                
                const colores = [
                    '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
                    '#FF9F40', '#E74C3C', '#C9CBCF', '#3498DB', '#FF9F40',
                    '#2ECC71', '#F39C12', '#8B5CF6', '#EC4899', '#10B981',
                    '#F59E0B', '#EF4444', '#3B82F6', '#8B5A00', '#14B8A6',
                    '#F97316', '#06B6D4', '#84CC16', '#A855F7', '#F43F5E',
                    '#6366F1', '#22C55E', '#EAB308', '#D946EF', '#0EA5E9',
                    '#65A30D', '#DC2626', '#7C3AED', '#059669', '#CA8A04',
                    '#DB2777', '#2563EB', '#16A34A', '#EA580C', '#0284C7',
                    '#4D7C0F', '#BE123C', '#4F46E5', '#15803D', '#B45309',
                    '#9F1239', '#1D4ED8', '#166534', '#C2410C', '#075985'
                ];
                
                // Crear un dataset por cada puesto para que la leyenda muestre correctamente
                const datasets = info.map((item, index) => ({
                    label: this.agrupacion === 1 ? item.departamento : item.municipio + '(' + item.departamento + ')',
                    backgroundColor: colores[index % colores.length],
                    borderWidth: 0,
                    borderSkipped: false,
                    borderRadius: 4,
                    data: [item.total_militantes],
                    maxBarThickness: 30,
                }));
                
                this.barChartData = {                
                    datasets: datasets,
                    labels: ['Militantes por Puesto']
                };
            },
        },
        computed: {
            totalMilitantes(){
                return this.infoCoordinador.reduce((acc, curr) => acc + curr.total_militantes, 0);
            },
            mostrarMensajeSinResultados(){
                return this.busquedaRealizada && this.infoCoordinador.length === 0 && !this.loading && !this.lideresSublideres;
            }
        }
    }

</script>
<style scoped>
    .info-coordinadores{
        color: #000 !important;
        font-size: 1.1rem;
        margin: 0.5rem 0;
        padding: 0.5rem;
        background-color: #f8f9fa;
        border-radius: 8px;
        border-left: 4px solid #C60000;
    }
    
    h6 {
        color: #C60000;
        font-weight: 700;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
    }
    
    .btn {
        border-radius: 8px;
        font-weight: 600;
        padding: 0.5rem 1.5rem;
        transition: all 0.3s ease;
    }
    
    .btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    }
    
    .badge {
        font-size: 1rem;
        padding: 0.5rem 1rem;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    .badge:hover {
        transform: scale(1.1);
    }
    
    .meta-badge {
        font-size: 1.2rem;
        font-weight: 600;
        color: #333;
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        padding: 0.75rem 1.5rem;
        border-radius: 12px;
        border-left: 4px solid #C60000;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        display: inline-block;
        margin: 0.5rem 0;
    }
    
    .meta-value {
        color: #C60000;
        font-size: 1.4rem;
        font-weight: 700;
        margin-left: 0.5rem;
    }
    
    /* Switch de agrupación */
    .agrupacion-switch {
        display: inline-flex;
        background-color: #f8f9fa;
        border-radius: 12px;
        padding: 0.5rem;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        border: 2px solid #e9ecef;
    }
    
    .switch-label {
        position: relative;
        margin: 0;
        cursor: pointer;
        padding: 0.75rem 1.5rem;
        border-radius: 8px;
        transition: all 0.3s ease;
        font-weight: 600;
        font-size: 0.95rem;
        color: #6c757d;
    }
    
    .switch-label:hover {
        color: #495057;
    }
    
    .switch-label.active {
        background: linear-gradient(135deg, #C60000 0%, #8B0000 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(198, 0, 0, 0.3);
    }
    
    .switch-input {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }
    
    .switch-text {
        user-select: none;
    }

    /* Estilos del mensaje de alerta */
    .alert-warning {
        background: linear-gradient(135deg, #fff9e6 0%, #fff3cd 100%);
        border: 2px solid #ffc107;
        border-radius: 12px;
        padding: 20px;
        color: #856404;
        box-shadow: 0 4px 12px rgba(255, 193, 7, 0.2);
    }

    .alert-warning i {
        font-size: 24px;
        margin-right: 10px;
        color: #ffc107;
    }

    .alert-warning strong {
        display: block;
        font-size: 18px;
        margin-bottom: 5px;
        color: #856404;
    }

    .alert-warning p {
        font-size: 14px;
        color: #856404;
    }
</style>